import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useAuth } from '../../Context/auth';
import MenuLateral from '../../Components/MenuPrincipal/MenuLateral';
import '../../Empresas/formulario.css';

function APagarForm() {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const { id } = useParams();
    const isEdit = !!id;

    const [formData, setFormData] = useState({
        numero_doc: '',
        status: 'Em aberto',
        data_cadastro: new Date().toISOString().split('T')[0],
        data_vencimento: '',
        data_pagamento: '',
        empresa_id: '',
        descricao: '',
        valor_subtotal: '',
        desconto: '',
        acrescimos: '',
        valor_total: '',
        forma_pagamento: 'Boleto',
        observacoes: '',
        prazo: ''
    });

    const [loading, setLoading] = useState(false);
    const [empresas, setEmpresas] = useState([]);

    const formaPagamentoOptions = ['Boleto', 'Pix', 'Cartão de Crédito', 'Transferência', 'Dinheiro'];

    useEffect(() => {
        const fetchEmpresas = async () => {
            try {
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;
                const response = await fetch(`${API_URL}/api/empresas`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (response.ok) {
                    const data = await response.json();
                    setEmpresas(data);
                }
            } catch (error) {
                console.error("Erro ao carregar empresas:", error);
            }
        };

        const fetchLancamento = async () => {
            setLoading(true);
            try {
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;
                const response = await fetch(`${API_URL}/api/financeiro/pagar`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                if (response.ok) {
                    const data = await response.json();
                    const lancamento = data.find(l => String(l.id) === String(id));
                    if (lancamento) {
                        setFormData({
                            numero_doc: lancamento.numero_doc || '',
                            status: lancamento.status || 'Em aberto',
                            data_cadastro: lancamento.data_cadastro ? lancamento.data_cadastro.split('T')[0] : '',
                            data_vencimento: lancamento.data_vencimento ? lancamento.data_vencimento.split('T')[0] : '',
                            data_pagamento: lancamento.data_pagamento ? lancamento.data_pagamento.split('T')[0] : '',
                            empresa_id: lancamento.empresa_id,
                            descricao: lancamento.descricao || '',
                            valor_subtotal: lancamento.valor_subtotal || 0,
                            desconto: lancamento.desconto || 0,
                            acrescimos: lancamento.acrescimos || 0,
                            valor_total: lancamento.valor_total,
                            forma_pagamento: lancamento.forma_pagamento,
                            observacoes: lancamento.observacoes || '',
                            prazo: lancamento.prazo || ''
                        });
                    } else {
                        Swal.fire("Erro", "Lançamento não encontrado.", "error");
                        navigate('/app/financeiroapagar');
                    }
                }
            } catch (error) {
                console.error("Erro ao carregar lançamento:", error);
            } finally {
                setLoading(false);
            }
        };

        if (currentUser) {
            fetchEmpresas();
            if (isEdit) {
                fetchLancamento();
            }
        }
    }, [id, currentUser, isEdit, navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const [localSaving, setLocalSaving] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loading || localSaving) return;

        setLocalSaving(true);
        setLoading(true);

        try {
            let currentStatus = formData.status;

            if (formData.data_pagamento && formData.status !== 'Pago') {
                const result = await Swal.fire({
                    title: 'Confirmação',
                    text: 'A data de pagamento foi informada. Deseja alterar o status para Pago?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                });

                if (result.isConfirmed) {
                    currentStatus = 'Pago';
                }
            }

            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;
            const method = isEdit ? 'PUT' : 'POST';
            const url = isEdit ? `${API_URL}/api/financeiro/pagar/${id}` : `${API_URL}/api/financeiro/pagar`;

            const payload = isEdit ? {
                ...formData,
                status: currentStatus // Envia o status atualizado
            } : {
                lancamento: {
                    fornecedor_id: formData.empresa_id,
                    ...formData,
                    status: currentStatus
                }
            };

            const response = await fetch(url, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || "Erro ao salvar lançamento.");
            }

            Swal.fire("Sucesso", "Lançamento salvo com sucesso!", "success");
            navigate('/app/financeiroapagar');

        } catch (error) {
            Swal.fire("Erro", error.message, "error");
        } finally {
            setLoading(false);
            setLocalSaving(false);
        }
    };

    return (
        <div className="form-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />
            <div className="content-with-sidebar">
                <div className="page-header">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-link text-secondary p-0" onClick={() => navigate('/app/financeiroapagar')} title="Voltar">
                            <i className="fas fa-arrow-left fa-lg"></i>
                        </button>
                        <h1 className="page-title m-0">
                            {id ? 'Editar' : 'Novo'} <span className="highlight">Conta a Pagar</span>
                        </h1>
                    </div>
                </div>

                <div className="form-card-container">
                    <div className="form-container">
                        {/* Simulated Tabs for visual consistency */}
                        <ul className="nav nav-tabs mb-3" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className="nav-link active" type="button">Dados do Lançamento</button>
                            </li>
                        </ul>

                        <form onSubmit={handleSubmit}>
                            <div className="tab-content">
                                <div className="tab-pane show active" role="tabpanel">

                                    <div className="form-section-card">
                                        <h5 className="form-section-title">Informações Gerais</h5>
                                        <div className="row g-3">
                                            <div className="col-md-3">
                                                <label className="form-label">Número Documento</label>
                                                <input type="text" className="form-control" name="numero_doc" value={formData.numero_doc} onChange={handleChange} placeholder="" />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label">Status</label>
                                                <select className="form-select" name="status" value={formData.status} onChange={handleChange} required>
                                                    <option value="Em aberto">Em aberto</option>
                                                    <option value="Pago">Pago</option>
                                                    <option value="Cancelado">Cancelado</option>
                                                </select>
                                            </div>
                                            <div className="col-md-2">
                                                <label className="form-label">Data de Cadastro</label>
                                                <input type="date" className="form-control" name="data_cadastro" value={formData.data_cadastro} onChange={handleChange} required />
                                            </div>
                                            <div className="col-md-2">
                                                <label className="form-label">Prazo (dias)</label>
                                                <input type="number" className="form-control" name="prazo" value={formData.prazo} onChange={handleChange} placeholder="0" />
                                            </div>
                                            <div className="col-md-2">
                                                <label className="form-label">Data de Vencimento</label>
                                                <input type="date" className="form-control" name="data_vencimento" value={formData.data_vencimento} onChange={handleChange} required />
                                            </div>
                                        </div>

                                        <div className="row g-3 mt-2">
                                            <div className="col-md-6">
                                                <label className="form-label">Empresa (Fornecedor)</label>
                                                <select className="form-select" name="empresa_id" value={formData.empresa_id} onChange={handleChange} required>
                                                    <option value="">Selecione...</option>
                                                    {empresas.map(emp => (
                                                        <option key={emp.id} value={emp.id}>{emp.nome}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label">Descrição</label>
                                                <input type="text" className="form-control" name="descricao" value={formData.descricao} onChange={handleChange} placeholder="Ex: Compra de Material" />
                                            </div>
                                        </div>

                                        <div className="row g-3 mt-2">
                                            <div className="col-md-3">
                                                <label className="form-label">Valor Subtotal</label>
                                                <input type="number" step="0.01" className="form-control" name="valor_subtotal" value={formData.valor_subtotal} onChange={handleChange} placeholder="0.00" />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label">Desconto</label>
                                                <input type="number" step="0.01" className="form-control" name="desconto" value={formData.desconto} onChange={handleChange} placeholder="0.00" />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label">Acréscimo</label>
                                                <input type="number" step="0.01" className="form-control" name="acrescimos" value={formData.acrescimos} onChange={handleChange} placeholder="0.00" />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label fw-bold">Valor Total</label>
                                                <input type="number" step="0.01" className="form-control bg-light fw-bold" name="valor_total" value={formData.valor_total} readOnly />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-section-card">
                                        <h5 className="form-section-title">Pagamento</h5>
                                        <div className="row g-3">
                                            <div className="col-md-4">
                                                <label className="form-label">Data de Pagamento</label>
                                                <input type="date" className="form-control" name="data_pagamento" value={formData.data_pagamento} onChange={handleChange} />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Forma de Pagamento</label>
                                                <select className="form-select" name="forma_pagamento" value={formData.forma_pagamento} onChange={handleChange}>
                                                    {formaPagamentoOptions.map(opt => (
                                                        <option key={opt} value={opt}>{opt}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-12">
                                                <label className="form-label">Observações</label>
                                                <textarea className="form-control" name="observacoes" rows="3" value={formData.observacoes} onChange={handleChange}></textarea>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="form-actions-bar">
                                <button type="button" className="btn btn-outline-secondary btn-acao" onClick={() => navigate('/app/financeiroapagar')}>
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-primary btn-acao" disabled={loading || localSaving}>
                                    {(loading || localSaving) ? 'Salvando...' : (id ? 'Salvar Alterações' : 'Salvar')}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default APagarForm;
